import { useMemo } from "react";
import type { Permission, PersonnelTmdPermission } from "src/api/Tmd.dtos";
import hasPermission from "src/utilities/hasPermission";

const useHasPermission = (
    personnelTmdPermissions: PersonnelTmdPermission[],
    permission: Permission,
    trialId?: number,
    institutionId?: number,
): boolean => {
    return useMemo(() => {
        return hasPermission(personnelTmdPermissions, permission, trialId, institutionId);
    }, [personnelTmdPermissions, permission, trialId, institutionId]);
};

export default useHasPermission;
